<template>
  <CustomModal
    class="kick-user-modal"
    :is-modal-open="isOpen"
    @toggleModal="closeModal"
    @onClickAway="closeModal"
    :overlay="'dark'"
    :with-header="false"
    :with-footer="false"
    custom-classes="tw:h-screen tw:md:h-auto tw:w-screen tw:md:max-w-[636px] tw:md:w-[636px] tw:md:rounded-md tw:rounded-none"
  >
    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:w-full">
      <div class="tw:mt-2 tw:flex tw:pt-6 tw:pb-4 tw:text-center">
        {{ `Are you sure you want to remove ${userEmail ?? 'this user'} from the organisation?` }}
      </div>

      <div class="tw:w-full tw:flex tw:justify-center tw:py-6">
        <MainButton size="medium" class="tw:px-9 tw:mr-2" @click="confirmKick">
          <span v-if="!isKicking">{{ 'Continue' }}</span>
          <span v-if="isKicking">
            <SmallDotLoader color="#fff" />
          </span>
        </MainButton>
        <GhostButton size="medium" class="tw:px-9" @click="closeModal">{{ 'Cancel' }}</GhostButton>
      </div>
    </div>
  </CustomModal>
</template>

<script setup>
import CustomModal from '@/components/base/CustomModal.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'

defineProps({
  isOpen: Boolean,
  isKicking: Boolean,
  userEmail: String,
})

const emit = defineEmits(['toggleModal', 'confirmKick'])
const toggleModal = value => emit('toggleModal', value)
const confirmKick = () => emit('confirmKick')

const closeModal = () => {
  toggleModal(false)
}
</script>
